export enum IneligibilityReason {
  StateNotSupported = 'stateNotSupported',
  InsuranceNotSupported = 'insuranceNotSupported',
}
